import { IItemCheck } from "./IItemCheck";

export class OneDriveRootItemCheck implements IItemCheck {
    doesItemExist = async () => true;
}
